import clsx from 'clsx';
import { observer } from 'mobx-react-lite';

import { useDraggable } from 'src/features/drilling-chart/features/editing/view/hooks/use-draggable';
import { WellTypeIcon } from 'src/features/well-type-icon';
import { ColoredCard } from 'src/shared/components/colored-card';
import { hasValue } from 'src/shared/utils/common';

import type { RigsViewSettingsProvider } from '../../drilling-rigs-chart/rigs-view-settings-provider';
import type { SidebarWellRigOperation } from '../entities';

import styles from './pad.module.scss';
import { WellTitle } from './well-title';

type Props = {
  well: SidebarWellRigOperation;
  onWellClick(wellId: number | string): void;
  viewSettingsProvider: RigsViewSettingsProvider;
};

export const WellComponent = observer(function WellComponent({ well, onWellClick, viewSettingsProvider }: Props) {
  const { listeners, isDragging } = useDraggable({
    id: well.getKey('draggable'),
    dataItem: well,
  });

  function onWellInfoSidebarOpen(wellId: number | null): void {
    if (hasValue(wellId)) {
      onWellClick(wellId);
    }
  }

  return (
    <ColoredCard
      cardColor={viewSettingsProvider.getWellColor(well)}
      title={<WellTitle well={well} listeners={listeners} />}
      text={well.attributes.length ? well.attributes.join(' - ') : undefined}
      icons={<WellTypeIcon iconName={well.wellTypeIcon} className={styles.wellIcon} />}
      showExpandButton
      className={clsx(styles.well, isDragging && styles.wellDragging)}
      onShowInfo={() => onWellInfoSidebarOpen(well.wellId)}
    />
  );
});
